import { createComponent, createHook } from 'reakit-system';
import { ButtonHTMLProps as ReakitButtonHTMLProps } from 'reakit';
import { ButtonHTMLAttributes } from 'react';
import { StylesOptions, useStyles } from '../hooks/useStyles';
import { useFocusable } from '../hooks/useFocusable';
import { WHCM } from '../constants';

export type UtilityButtonHTMLProps = ButtonHTMLAttributes<HTMLButtonElement> &
  ReakitButtonHTMLProps;
export type UtilityButtonOptions = StylesOptions;
export type UtilityButtonProps = UtilityButtonOptions & UtilityButtonHTMLProps;

export const useUtilityButton = createHook<
  UtilityButtonOptions,
  UtilityButtonProps
>({
  name: 'UtilityButton',
  compose: [useFocusable, useStyles],
  useOptions(options) {
    return {
      ...options,
      styles: {
        verticalAlign: 'middle',
        color: 'gray-60',
        '&:hover': {
          color: 'gray-80',
        },
        '&:active': {
          color: 'gray-90',
        },

        [WHCM]: {
          borderWidth: 1,
        },
        ...options.styles,
      },
    };
  },
});

export const UtilityButton = createComponent({
  as: 'button',
  useHook: useUtilityButton,
  memo: true,
});
